import Vue from 'vue'
import Vuex from 'vuex'
import {list, getAdditionalByID, listAdditionalLikely, getAdditionalLikely, listPaymentStatus} from '@/helpers/api/additionals'
import {getProjectRequest, isCurrentProjectRequest} from '@/helpers/projectContext'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		additionalTypes: [
			{ id: 1, name: 'Obra Extraordinaria' },
			{ id: 2, name: 'Aumento de Obra' },
			{ id: 3, name: 'Disminución de Obra' }
		],
		additionalCostTypes: [
			{ id: 1, name: 'Suma Alzada [SA]' },
			{ id: 2, name: 'Serie de Precios Unitarios [SPU]' },
			{ id: 3, name: 'Valor Proforma [VPF]' }
		],
		listado: {
			status: 99,
			count: 0,
			total_additional: 0,
			data: []
		},
		listadoTotal: 0,
		listadoInformativeTable: {
			status: 99,
			count: 0,
			total_additional: 0,
			data: []
		},
		listadoInformativeTableTotal: 0,
		listadoPosibles: {
			status: 99,
			count: 0,
			total_additional: 0,
			data: []
		},
		listadoPosiblesTotal: 0,
		createAdicionalModal: false,
		createPosibleAdicionalModal: false,
		draftToLoad: null,
		listingOrder: 1,
		selectedType: 2,
		currentAdicional: null,
		currentAdicionalPosible: null,
		initialDataAdicional: null,
		loadingChangeVisualizationStatus: [],
		specialtyFilter: [],
		additionalTypeFilter: [],
		responsableFilter: [],
		estadoFilter: [],
	},
	mutations: {
		setListado(state, adicionales){
			state.listado = adicionales
			state.listadoTotal = adicionales.total_additional
		},
		setListadoInformativeTable(state, adicionales){
			state.listadoInformativeTable = adicionales
			state.listadoInformativeTableTotal = adicionales.total_additional
		},
		setListadoPosibles(state, adicionales){
			state.listadoPosibles = adicionales
			state.listadoPosiblesTotal = adicionales.total_additional
		},
		setCurrentAdicional(state, adicional){
			state.currentAdicional = adicional
		},
		setCurrentAdicionalPosible(state, adicional){
			state.currentAdicionalPosible = adicional
		},
		setBorradorRDI(state, rdi){
			state.borradorRDI = rdi
		},
		setSelectedType(state, type){
			state.selectedType = type
		},
		setListingOrder(state, new_order){
			state.listingOrder = new_order
		},
		setCreateAdicionalModal(state, status){
			state.createAdicionalModal = status
			if(!status) {
				state.draftToLoad = null
			}
		},
		setCreatePosibleAdicionalModal(state, status){
			state.createPosibleAdicionalModal = status
			if(!status) {
				state.draftToLoad = null
			}
		},
		setDraftToLoad(state, draft){
			state.draftToLoad = draft
		},
		setInitialDataAdicional(state, data){
			state.initialDataAdicional = data
		},
		setRdiGraphsDataCountBySpecialty(state, data){
			state.rdiGraphsDataCountBySpecialty = data
		},
		addLoadingChangeVisualizationStatus(state, newItemID){
			const changingStatus = [...state.loadingChangeVisualizationStatus]
			const found = changingStatus.find((item) => item === newItemID)
			if(!found){
				changingStatus.push(newItemID)
			}
			state.loadingChangeVisualizationStatus = changingStatus
		},
		removeLoadingChangeVisualizationStatus(state, itemID){
			const changingStatus = [...state.loadingChangeVisualizationStatus]
			const foundIndex = changingStatus.findIndex((item) => item === itemID)
			if(foundIndex !== -1){
				changingStatus.splice(foundIndex, 1)
			}
			state.loadingChangeVisualizationStatus = changingStatus
		},
		setEstadoFilter(state, value){
			state.estadoFilter = value
		},
		setSpecialtyFilter(state, value){
			state.specialtyFilter = value
		},
		setResponsableFilter(state, value){
			state.responsableFilter = value
		},
		setAdditionalTypeFilter(state, value){
			state.additionalTypeFilter = value
		},
		resetForProject(state){
			state.listado = {status: 99, count: 0, total_additional: 0, data: []}
			state.listadoInformativeTable = {status: 99, count: 0, total_additional: 0, data: []}
			state.listadoPosibles = {status: 99, count: 0, total_additional: 0, data: []}
			state.listadoTotal = 0
			state.listadoInformativeTableTotal = 0
			state.listadoPosiblesTotal = 0
			state.currentAdicional = null
			state.currentAdicionalPosible = null
			state.initialDataAdicional = null
			state.draftToLoad = null
			state.specialtyFilter = []
			state.additionalTypeFilter = []
			state.responsableFilter = []
			state.estadoFilter = []
			state.loadingChangeVisualizationStatus = []
			state.createAdicionalModal = false
			state.createPosibleAdicionalModal = false
		},
	},
	actions: {
		async getAdditionalByID(context, query){
			const data = {
				additional_id: query.additional_id
			}
			!query.dontSetLoading && context.commit('setCurrentAdicional', {loading: true})
			const additional = await getAdditionalByID(data)
			if(additional.code === 200){
				let additionalData = additional.additional
				additionalData.prev_seen_by_me = query.seen_by_me
				context.commit('setCurrentAdicional', additionalData)
			}
			else{
				context.commit('setCurrentAdicional', null)
			}
		},
		async getAdditionals(context, query){
			const request = getProjectRequest(query.project_id)
			let page = 1
			let per_page = 50
			if(query.page){
				page = query.page
			}

			const data = {
				project_id: query.project_id,
				order: context.state.listingOrder,
				start: per_page * (page - 1),
				limit: per_page,

				// statuses: query.statuses,
				// filtered_specialties: query.filtered_specialties,
				// filtered_subjects: query.filtered_subjects,
				// filtered_responsable: query.filtered_responsable,
				// filtered_types: query.filtered_types,

				statuses: context.state.estadoFilter,
				filtered_specialties: context.state.specialtyFilter,
				filtered_responsable: context.state.responsableFilter,
				filtered_types: context.state.additionalTypeFilter
			}

			let listing = Object.assign(context.state.listado, {status: 99})
			context.commit('setListado', listing)
			const additionals = await list(data)
			if(isCurrentProjectRequest(request.projectId, request.generation) && additionals.code === 200){
				context.commit('setListado', {
					status: 1,
					count: additionals.additional.length,
					data: additionals.additional,
					total_additionals: additionals.total_additional,
				})
			}
		},
		async getAdditionalInformativeTable(context, query){
			const request = getProjectRequest(query.project_id)
			let page = 1
			let per_page = 50
			if(query.page){
				page = query.page
			}

			const data = {
				project_id: query.project_id,
				currency_id: query.currency_id,
				statuses: query.statuses,
				order: context.state.listingOrder,
				start: per_page * (page - 1),
				limit: per_page
			}

			let listing = Object.assign(context.state.listadoInformativeTable, {status: 99})
			context.commit('setListadoInformativeTable', listing)
			const additionals = await listPaymentStatus(data)
			if(isCurrentProjectRequest(request.projectId, request.generation) && additionals.code === 200){
				context.commit('setListadoInformativeTable', {
					status: 1,
					count: additionals.additional.length,
					data: additionals.additional,
					payment_statuses: additionals.agps,
					currency_info: additionals.currency_info,
					total_additional: additionals.total_additional,
				})
			}
		},
		async getAdditionalsLikely(context, query){
			const request = getProjectRequest(query.project_id)
			let page = 1
			let per_page = 50
			if(query.page){
				page = query.page
			}

			const data = {
				project_id: query.project_id,
				statuses: query.statuses,
				status: query.status,
				order: context.state.listingOrder,
				start: per_page * (page - 1),
				limit: per_page
			}

			let listing = Object.assign(context.state.listadoPosibles, {status: 99})
			context.commit('setListadoPosibles', listing)
			const additionals = await listAdditionalLikely(data)
			if(isCurrentProjectRequest(request.projectId, request.generation) && additionals.code === 200){
				context.commit('setListadoPosibles', {
					status: 1,
					count: additionals.additional.length,
					data: additionals.additional,
					total_additional: additionals.total_additional,
				})
			}
		},
		async getAdditionalLikely(context, query){
			const data = {
				additional_likely_id: query.additional_likely_id
			}
			!query.dontSetLoading && context.commit('setCurrentAdicionalPosible', {loading: true})
			const additional = await getAdditionalLikely(data)
			if(additional.code === 200){
				let additionalData = additional.additional
				context.commit('setCurrentAdicionalPosible', additionalData)
			}
			else{
				context.commit('setCurrentAdicionalPosible', null)
			}
		},
		updateAdditionalLocally(context, newAdditionalData){
			const additionalIndex = context.state.listado.data.findIndex((additional) => { return additional.id === newAdditionalData.id })
			if(additionalIndex !== -1){
				const additionals = [...context.state.listado.data]
				additionals[additionalIndex] = {...additionals[additionalIndex], ...newAdditionalData}
				context.commit('setListado', {
					status: 1,
					count: context.state.listado.count,
					data: additionals,
					total_additionals: context.state.listado.total_additional
				})
			}
		}
	},
	getters: {
		currentTarea: state => {
			return state.currentTarea
		}
	}
})

export default store